var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,13.833v9.333h6.222L18.5,31.3V5.7l-7.778,8.133Zm21,4.667a7.269,7.269,0,0,0-3.889-6.48V24.9A7.057,7.057,0,0,0,25.5,18.5Zm-3.889-14V7.78A11.148,11.148,0,0,1,29.389,18.5a11.148,11.148,0,0,1-7.778,10.72V32.5A14.319,14.319,0,0,0,32.5,18.5,14.319,14.319,0,0,0,21.611,4.5Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#353e8e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/icon_volume.323a4f5f38f22c755b6fce927623ed53.svg";
export { ForwardRef as ReactComponent };